import { render, staticRenderFns } from "./StoreTop.vue?vue&type=template&id=fa8b924e&scoped=true"
import script from "./StoreTop.vue?vue&type=script&lang=js"
export * from "./StoreTop.vue?vue&type=script&lang=js"
import style0 from "./StoreTop.vue?vue&type=style&index=0&id=fa8b924e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8b924e",
  null
  
)

export default component.exports